export default __webpack_public_path__ + "static/media/call-action-bg.10d77022.png";